export const translations = {
  en: {
    // Header / nav
    brand: "HISD Parent Helper",
    nav_home: "Home",
    nav_knowledge: "Knowledge Base",
    nav_chat: "Chat",
    nav_tutor: "Tutor",
    nav_dashboard: "My Portal",
    nav_admin: "Admin",
    nav_login: "Log In",
    nav_signup: "Sign Up",
    nav_logout: "Log Out",
    lang_label: "Español",

    // Hero
    hero_eyebrow: "Houston Independent School District",
    hero_title: "Answers for every Houston ISD family",
    hero_subtitle: "A community engagement portal designed to assist parents.",
    hero_cta_chat: "Start asking questions",
    hero_cta_helper: "Talk to a real person",

    // Spanish banner (shown to everyone on home)
    es_banner_title: "\u00bfHablas espa\u00f1ol?",
    es_banner_text: "Este portal es para ti. Haz cualquier pregunta sobre la escuela de tu hijo en espa\u00f1ol y recibe respuestas claras al instante.",
    es_banner_cta: "Usar en Espa\u00f1ol",

    // Chat
    chat_title: "HISD Parent Helper",
    chat_eyebrow: "AI Family Assistant",
    chat_subtitle: "Type your question below. Answers are for general guidance \u2014 always confirm details with your school.",
    chat_placeholder: "Ask about enrollment, bus routes, meals, calendar...",
    chat_send: "Send",
    chat_empty_title: "How can we help you today? Ask me anything.",
    chat_empty_text: "Pick a topic below or type your own question.",
    chat_thinking: "Helper is typing...",
    chat_disclaimer: "AI guidance. For account-specific help, sign in and request a live Parent Helper.",
    starter_1: "How do I enroll my child in HISD?",
    starter_2: "What are the school meal options?",
    starter_3: "How do I find my child's bus route?",
    starter_4: "When are the school holidays?",

    // Live helper section
    helper_title: "Need to speak with a real person?",
    helper_text: "Create a free account and request a live Parent Helper. A friendly HISD family representative will follow up with you personally.",
    helper_cta: "Request a Parent Helper",
    helper_signin: "Sign in to request",
    trust_free: "Free",
    trust_private: "Private",
    trust_247: "Available 24/7",
    trust_bilingual: "English & Espa\u00f1ol",
    helper_inline: "Prefer to talk to a real person?",

    // Features
    feat_title: "Everything HISD families need, in one place",
    feat_1_title: "Instant AI answers",
    feat_1_text: "Get clear answers about school info any time, in English or Spanish.",
    feat_2_title: "Live Parent Helpers",
    feat_2_text: "Request a real HISD family representative when you need a personal touch.",
    feat_3_title: "Built for every family",
    feat_3_text: "Fully bilingual and designed to be welcoming, simple, and stress-free.",

    tutor_eyebrow: "Free Online Tutoring",
    tutor_title: "Does your child need a FREE online tutor?",
    tutor_text: "Connect your child with a caring online tutor for homework help, reading, math and more \u2014 at no cost to your family. Get one-on-one support whenever they need a little extra help to succeed.",
    tutor_badge: "Coming soon",
    tutor_credits_note: "Covered by your school's credits",

    events_title: "Upcoming Events & Important Dates",
    events_subtitle: "Mark your calendar \u2014 key dates for HISD families this semester.",
    resources_title: "Free Resources for Parents",
    resources_subtitle: "Helpful guides and tools to support your child's education \u2014 always free.",
    news_title: "Latest News",
    news_subtitle: "Stay in the loop with updates from around the district.",
    read_more: "Read more",
    view_resource: "View resource",
    courses_title: "Free Online Courses for Parents",
    courses_subtitle: "Short, self-paced courses to help you support your child and navigate school with confidence.",
    course_start: "Start course",
    social_title: "Free Social Services & Resources",
    social_subtitle: "Support for your whole family \u2014 connecting you to free community help across Houston.",
    social_help_title: "Not sure where to start?",
    social_help_text: "Our team can point you to the right free service for your family's needs.",
    social_cta: "Get connected",

    // Auth
    login_title: "Welcome back",
    login_subtitle: "Log in to your parent portal.",
    register_title: "Create your parent account",
    register_subtitle: "Join to request live help and save your conversations.",
    field_name: "Full name",
    field_email: "Email",
    field_password: "Password",
    field_language: "Preferred language",
    btn_login: "Log In",
    btn_register: "Create Account",
    have_account: "Already have an account?",
    no_account: "New here?",
    or: "or",

    // Dashboard (parent)
    dash_welcome: "Welcome",
    dash_subtitle: "Your Houston ISD parent portal.",
    dash_new_request: "Request a Parent Helper",
    dash_requests_title: "My help requests",
    dash_no_requests: "You haven't requested a Parent Helper yet.",
    dash_ask_ai: "Ask the AI Helper",
    request_topic: "What do you need help with?",
    request_topic_ph: "e.g. Enrollment, transportation, special education",
    request_school: "Your child's school (optional)",
    request_phone: "Phone number (optional)",
    request_message: "Tell us more",
    request_message_ph: "Share details so we can help you faster...",
    request_submit: "Submit request",
    request_cancel: "Cancel",
    request_success: "Your request was sent! A Parent Helper will reach out soon.",

    // Status
    status_pending: "Pending",
    status_in_progress: "In progress",
    status_resolved: "Resolved",

    // Admin
    admin_title: "Helper Dashboard",
    admin_subtitle: "Manage parent help requests and see what families are asking.",
    admin_tab_requests: "Help Requests",
    admin_tab_questions: "Parent Questions",
    admin_stat_parents: "Registered parents",
    admin_stat_questions: "Questions asked",
    admin_stat_pending: "Pending requests",
    admin_stat_resolved: "Resolved",
    admin_notes: "Internal notes",
    admin_notes_ph: "Add a note about this request...",
    admin_save: "Save",
    admin_no_questions: "No questions asked yet.",

    footer_note: "This portal provides general guidance and is not the official HISD website. For official information visit houstonisd.org.",

    role_parent: "Parent",
    role_principal: "Principal",
    field_account_type: "I am a...",
    field_school: "School",
    select_school: "Select your school",
    principal_note: "Principals manage their school's AI credit balance and billing.",
    nav_billing: "Billing",
    nav_schools: "Schools",
    credits: "credits",
    credits_remaining: "credits remaining",
    school_credits: "School AI Credits",
    dash_credits_hint: "Each AI question uses 1 credit and a live helper request uses 5. Credits come from your school's pool.",
    billing_title: "School Billing & Credits",
    billing_subtitle: "Manage your school's AI credit balance. Parents use the portal for free \u2014 their questions draw from this pool.",
    billing_balance: "Available credits",
    billing_spent: "Credits used",
    billing_parents: "Registered parents",
    billing_buy_title: "Buy a credit pack",
    buy_now: "Buy now",
    low_credits_warning: "Your school is running low on credits. Buy more so parents can keep asking questions.",
    request_more: "Request more credits",
    transactions_title: "Purchase history",
    no_transactions: "No purchases yet.",
    per_question: "1 credit / AI question",
    per_helper: "5 credits / live helper request",
    credits_word: "credits",
    pay_success_title: "Payment successful!",
    pay_success_text: "Your credits have been added to your school's pool.",
    pay_processing: "Confirming your payment...",
    pay_failed: "We couldn't confirm your payment yet. If you were charged, it will update shortly.",
    back_to_billing: "Back to billing",
    credits_added: "credits added",
    admin_tab_schools: "Schools",
    admin_new_school: "Add school",
    school_name: "School name",
    initial_credits: "Starting credits",
    create_school: "Create school",
    grant: "Grant",
    grant_credits_ph: "Credits",
    school_balance: "Balance",
    no_schools: "No schools yet. Add one to get started.",
  },
  es: {
    brand: "Ayudante para Padres HISD",
    nav_home: "Inicio",
    nav_knowledge: "Base de Conocimiento",
    nav_chat: "Chat",
    nav_tutor: "Tutor",
    nav_dashboard: "Mi Portal",
    nav_admin: "Admin",
    nav_login: "Iniciar Sesi\u00f3n",
    nav_signup: "Registrarse",
    nav_logout: "Cerrar Sesi\u00f3n",
    lang_label: "English",

    hero_eyebrow: "Distrito Escolar Independiente de Houston",
    hero_title: "Respuestas para cada familia de Houston ISD",
    hero_subtitle: "Un portal de participaci\u00f3n comunitaria dise\u00f1ado para ayudar a los padres.",
    hero_cta_chat: "Empezar a preguntar",
    hero_cta_helper: "Hablar con una persona",

    es_banner_title: "\u00a1Bienvenidos, familias hispanohablantes!",
    es_banner_text: "Este portal es para ti. Haz cualquier pregunta sobre la escuela de tu hijo en espa\u00f1ol y recibe respuestas claras al instante.",
    es_banner_cta: "Ya est\u00e1s en Espa\u00f1ol",

    chat_title: "Ayudante para Padres de HISD",
    chat_eyebrow: "Asistente Familiar con IA",
    chat_subtitle: "Escribe tu pregunta abajo. Las respuestas son orientaci\u00f3n general: siempre confirma los detalles con tu escuela.",
    chat_placeholder: "Pregunta sobre inscripci\u00f3n, rutas de autob\u00fas, comidas, calendario...",
    chat_send: "Enviar",
    chat_empty_title: "\u00bfC\u00f3mo podemos ayudarte hoy? Preg\u00fantame lo que quieras.",
    chat_empty_text: "Elige un tema abajo o escribe tu propia pregunta.",
    chat_thinking: "El ayudante est\u00e1 escribiendo...",
    chat_disclaimer: "Orientaci\u00f3n con IA. Para ayuda personalizada, inicia sesi\u00f3n y solicita un Ayudante para Padres en vivo.",
    starter_1: "\u00bfC\u00f3mo inscribo a mi hijo en HISD?",
    starter_2: "\u00bfCu\u00e1les son las opciones de comida escolar?",
    starter_3: "\u00bfC\u00f3mo encuentro la ruta de autob\u00fas de mi hijo?",
    starter_4: "\u00bfCu\u00e1ndo son las vacaciones escolares?",

    helper_title: "\u00bfNecesitas hablar con una persona real?",
    helper_text: "Crea una cuenta gratis y solicita un Ayudante para Padres en vivo. Un amable representante familiar de HISD se comunicar\u00e1 contigo personalmente.",
    helper_cta: "Solicitar un Ayudante para Padres",
    helper_signin: "Inicia sesi\u00f3n para solicitar",
    trust_free: "Gratis",
    trust_private: "Privado",
    trust_247: "Disponible 24/7",
    trust_bilingual: "English & Espa\u00f1ol",
    helper_inline: "\u00bfPrefieres hablar con una persona real?",

    feat_title: "Todo lo que las familias de HISD necesitan, en un solo lugar",
    feat_1_title: "Respuestas instant\u00e1neas con IA",
    feat_1_text: "Obt\u00e9n respuestas claras sobre la escuela en cualquier momento, en ingl\u00e9s o espa\u00f1ol.",
    feat_2_title: "Ayudantes para Padres en vivo",
    feat_2_text: "Solicita un representante familiar real de HISD cuando necesites un toque personal.",
    feat_3_title: "Hecho para cada familia",
    feat_3_text: "Totalmente biling\u00fce y dise\u00f1ado para ser acogedor, simple y sin estr\u00e9s.",

    tutor_eyebrow: "Tutor\u00eda en l\u00ednea gratis",
    tutor_title: "\u00bfTu hijo necesita un tutor en l\u00ednea GRATIS?",
    tutor_text: "Conecta a tu hijo con un tutor en l\u00ednea atento para ayuda con la tarea, lectura, matem\u00e1ticas y m\u00e1s, sin costo para tu familia. Recibe apoyo personalizado siempre que necesite un poco de ayuda extra para tener \u00e9xito.",
    tutor_badge: "Pr\u00f3ximamente",
    tutor_credits_note: "Cubierto por los cr\u00e9ditos de tu escuela",

    events_title: "Eventos Pr\u00f3ximos y Fechas Importantes",
    events_subtitle: "Marca tu calendario: fechas clave para las familias de HISD este semestre.",
    resources_title: "Recursos Gratuitos para Padres",
    resources_subtitle: "Gu\u00edas y herramientas \u00fatiles para apoyar la educaci\u00f3n de tu hijo, siempre gratis.",
    news_title: "\u00daltimas Noticias",
    news_subtitle: "Mantente al d\u00eda con las novedades de todo el distrito.",
    read_more: "Leer m\u00e1s",
    view_resource: "Ver recurso",
    courses_title: "Cursos en L\u00ednea Gratis para Padres",
    courses_subtitle: "Cursos cortos a tu propio ritmo para ayudarte a apoyar a tu hijo y navegar la escuela con confianza.",
    course_start: "Comenzar curso",
    social_title: "Servicios Sociales y Recursos Gratuitos",
    social_subtitle: "Apoyo para toda tu familia: te conectamos con ayuda comunitaria gratuita en todo Houston.",
    social_help_title: "\u00bfNo sabes por d\u00f3nde empezar?",
    social_help_text: "Nuestro equipo puede indicarte el servicio gratuito adecuado para las necesidades de tu familia.",
    social_cta: "Con\u00e9ctate",

    login_title: "Bienvenido de nuevo",
    login_subtitle: "Inicia sesi\u00f3n en tu portal para padres.",
    register_title: "Crea tu cuenta de padre",
    register_subtitle: "\u00danete para solicitar ayuda en vivo y guardar tus conversaciones.",
    field_name: "Nombre completo",
    field_email: "Correo electr\u00f3nico",
    field_password: "Contrase\u00f1a",
    field_language: "Idioma preferido",
    btn_login: "Iniciar Sesi\u00f3n",
    btn_register: "Crear Cuenta",
    have_account: "\u00bfYa tienes una cuenta?",
    no_account: "\u00bfEres nuevo aqu\u00ed?",
    or: "o",

    dash_welcome: "Bienvenido",
    dash_subtitle: "Tu portal para padres de Houston ISD.",
    dash_new_request: "Solicitar un Ayudante para Padres",
    dash_requests_title: "Mis solicitudes de ayuda",
    dash_no_requests: "Todav\u00eda no has solicitado un Ayudante para Padres.",
    dash_ask_ai: "Preguntar al Ayudante con IA",
    request_topic: "\u00bfCon qu\u00e9 necesitas ayuda?",
    request_topic_ph: "ej. Inscripci\u00f3n, transporte, educaci\u00f3n especial",
    request_school: "La escuela de tu hijo (opcional)",
    request_phone: "N\u00famero de tel\u00e9fono (opcional)",
    request_message: "Cu\u00e9ntanos m\u00e1s",
    request_message_ph: "Comparte detalles para poder ayudarte m\u00e1s r\u00e1pido...",
    request_submit: "Enviar solicitud",
    request_cancel: "Cancelar",
    request_success: "\u00a1Tu solicitud fue enviada! Un Ayudante para Padres se comunicar\u00e1 pronto.",

    status_pending: "Pendiente",
    status_in_progress: "En proceso",
    status_resolved: "Resuelto",

    admin_title: "Panel de Ayudantes",
    admin_subtitle: "Gestiona las solicitudes de ayuda y observa lo que preguntan las familias.",
    admin_tab_requests: "Solicitudes de Ayuda",
    admin_tab_questions: "Preguntas de Padres",
    admin_stat_parents: "Padres registrados",
    admin_stat_questions: "Preguntas realizadas",
    admin_stat_pending: "Solicitudes pendientes",
    admin_stat_resolved: "Resueltas",
    admin_notes: "Notas internas",
    admin_notes_ph: "Agrega una nota sobre esta solicitud...",
    admin_save: "Guardar",
    admin_no_questions: "A\u00fan no se han hecho preguntas.",

    footer_note: "Este portal ofrece orientaci\u00f3n general y no es el sitio oficial de HISD. Para informaci\u00f3n oficial visita houstonisd.org.",

    role_parent: "Padre/Madre",
    role_principal: "Director(a)",
    field_account_type: "Soy...",
    field_school: "Escuela",
    select_school: "Selecciona tu escuela",
    principal_note: "Los directores gestionan el saldo de cr\u00e9ditos de IA y la facturaci\u00f3n de su escuela.",
    nav_billing: "Facturaci\u00f3n",
    nav_schools: "Escuelas",
    credits: "cr\u00e9ditos",
    credits_remaining: "cr\u00e9ditos restantes",
    school_credits: "Cr\u00e9ditos de IA de la escuela",
    dash_credits_hint: "Cada pregunta de IA usa 1 cr\u00e9dito y una solicitud de ayudante en vivo usa 5. Los cr\u00e9ditos provienen del fondo de tu escuela.",
    billing_title: "Facturaci\u00f3n y Cr\u00e9ditos de la Escuela",
    billing_subtitle: "Gestiona el saldo de cr\u00e9ditos de IA de tu escuela. Los padres usan el portal gratis: sus preguntas se descuentan de este fondo.",
    billing_balance: "Cr\u00e9ditos disponibles",
    billing_spent: "Cr\u00e9ditos usados",
    billing_parents: "Padres registrados",
    billing_buy_title: "Comprar un paquete de cr\u00e9ditos",
    buy_now: "Comprar ahora",
    low_credits_warning: "A tu escuela le quedan pocos cr\u00e9ditos. Compra m\u00e1s para que los padres puedan seguir preguntando.",
    request_more: "Solicitar m\u00e1s cr\u00e9ditos",
    transactions_title: "Historial de compras",
    no_transactions: "A\u00fan no hay compras.",
    per_question: "1 cr\u00e9dito / pregunta de IA",
    per_helper: "5 cr\u00e9ditos / solicitud de ayudante en vivo",
    credits_word: "cr\u00e9ditos",
    pay_success_title: "\u00a1Pago exitoso!",
    pay_success_text: "Tus cr\u00e9ditos se han a\u00f1adido al fondo de tu escuela.",
    pay_processing: "Confirmando tu pago...",
    pay_failed: "A\u00fan no pudimos confirmar tu pago. Si se te cobr\u00f3, se actualizar\u00e1 pronto.",
    back_to_billing: "Volver a facturaci\u00f3n",
    credits_added: "cr\u00e9ditos a\u00f1adidos",
    admin_tab_schools: "Escuelas",
    admin_new_school: "Agregar escuela",
    school_name: "Nombre de la escuela",
    initial_credits: "Cr\u00e9ditos iniciales",
    create_school: "Crear escuela",
    grant: "Otorgar",
    grant_credits_ph: "Cr\u00e9ditos",
    school_balance: "Saldo",
    no_schools: "A\u00fan no hay escuelas. Agrega una para comenzar.",
  },
};
